<script>
	import { onMount } from 'svelte'
	const getViewers = async () => {
		const response = await fetch('https://viewers.murka.me/add')
		const total = await response.text()

		return total
	}

	export let viewers = null;
	onMount(async () => {
		viewers = await getViewers();
	})
	
</script>

<main>
<blockquote>
    Nothing of, just stay focus on the goals, nobody cares about what you're doing, only your results from the decisions ⚡️
</blockquote>
Hi, I'm <b>Murka</b> aka <b>Danil Shaymurzin</b>.
<hr/>
cv: <s><a href="//murka.me/cv">murka.me/cv</a></s> (NOT OPEN TO WORK)
<hr/>
<b>Contact me:</b>
telegram: <a href="//t.me/shaymurzin">@shaymurzin</a>
email: murka@hey.com
<hr/>
<b>Keys:</b>
RSA: <a href="/keys/rsa.pub">download</a>  <a href="/keys/rsa.txt">see</a>
PGP: <a href="/keys/pgp.asc">download</a>  <a href="/keys/pgp.txt">see</a>
<hr/>
<b>Links:</b>
X: <a href="//x.com/shaymurzind">x.com/shaymurzind</a>
GitHub: <a href="//github.com/murka">github.com/murka</a>
LinkedIn: <a href="//linkedin.com/in/shaymurzin">linkedin.com/in/shaymurzin</a>
HuggingFace: <s><a href="//hf.co/murka">hf.co/murka</a></s> (inactive yet)
<hr/>

total page views: {viewers}
</main>

<style>
</style>
